import { useEffect, useState } from "react";
import OrderView from "../view-model/OrderView";

const AdminHome = () => {
    const [statsdata, setStatsdata] = useState(null);
    const [topStudents, setTopStudents] = useState([]);
    const [birthdays, setBirthdays] = useState([]);
    const [employeeLeaves, setEmployeeLeaves] = useState([]);
    const [firms, setFirms] = useState([]);
    const [deliveryPersons, setDeliveryPersons] = useState([]);

    useEffect(() => {
        // getDashboardSummary({ role: "ADMIN" })
        //     .then(setData)
        //     .catch(console.error);
    }, []);

    // if (!data) return <p>Loading...</p>;

    const formatINR = (amount = 0) =>
        amount.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
        });

    return (

        <div className="dashboard">

            {/* HEADER FILTERS */}
            <section className="filters">
                <select>
                    <option>Select Dashboard</option>
                    <option>Admin</option>
                    <option>Branch</option>
                </select>

                <select>
                    <option>Select Firm</option>
                    {firms.map((data, i) => (
                        <option key={i}>{data.name}</option>
                    ))}
                </select>

                <select>
                    <option>Select Delivery Person</option>
                    {deliveryPersons.map((data, i) => (
                        <option key={i}>{data.name}</option>
                    ))}
                </select>
            </section>

            {/* TODAY SUMMARY */}
            <section className="card">
                <h3>Today's School Summary</h3>

                <p>Total Employee: <b>{statsdata?.totalEmployee}</b></p>
                <p>Total Present Emp: <b>{statsdata?.totalPresentEmp}</b></p>
                <p>Total Absent Emp: <b>{statsdata?.totalAbsentEmp}</b></p>

                <p>Total NON RTE Student: <b>{statsdata?.totalStudent}</b></p>
                <p>Total RTE Student: <b>{statsdata?.totalStudentRte}</b></p>

                <p>
                    Total Students:{" "}
                    <b>{(statsdata?.totalStudent || 0) + (statsdata?.totalStudentRte || 0)}</b>
                </p>

                <p>Total Student's Absent: <b>{statsdata?.todayAbsentstd}</b></p>
            </section>

            {/* FEES SUMMARY */}
            <section className="card">
                <h3>Fees Summary</h3>

                <p>Current Session Amount: {formatINR(statsdata?.currentSessionAmount)}</p>
                <p>Last Month Amount: {formatINR(statsdata?.lastmonthAmount)}</p>
                <p>Current Month Amount: {formatINR(statsdata?.currentmonthAmount)}</p>
                <p>Last Session Amount: {formatINR(statsdata?.lastSessionAmount)}</p>
                <p>Today's Amount: {formatINR(statsdata?.todayAmount)}</p>

                <p>Total Paid: <b>{statsdata?.totalPaid}</b></p>
                <p>
                    Total Unpaid:{" "}
                    <b>{(statsdata?.totalStudent || 0) - (statsdata?.totalPaid || 0)}</b>
                </p>
            </section>

            {/* TOP STUDENTS */}
            <section className="card">
                <h3>Top Students</h3>

                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Terms</th>
                            <th>Percent</th>
                        </tr>
                    </thead>
                    <tbody>
                        {topStudents.map((data, i) => (
                            <tr key={i}>
                                <td>{data.name}</td>
                                <td>{data.count}</td>
                                <td>{data.percent}%</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            {/* TODAY'S BIRTHDAY */}
            <section className="card">
                <h3>Today's Birthday</h3>

                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Birthday</th>
                            <th>Age</th>
                        </tr>
                    </thead>
                    <tbody>
                        {birthdays.map((data, i) => (
                            <tr key={i}>
                                <td>{data.name}, {data.standard}</td>
                                <td>{new Date(data.dob).toLocaleDateString("en-GB")}</td>
                                <td>{data.ages} Year</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            {/* EMPLOYEE LEAVE */}
            <section className="card">
                <h3>Today's Employee Leave</h3>

                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Mobile No.</th>
                            <th>Leave</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employeeLeaves.map((data, i) => (
                            <tr key={i}>
                                <td>{data.name}</td>
                                <td>{data.mobileno}</td>
                                <td>{data.leave}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

        </div>
    );
};
export default AdminHome;